import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FilterResetIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      fill={color}
    >
      <path d="M20.317 9.843l-4.323 4.312-4.312-4.312-1.84 1.84 4.312 4.312-4.312 4.323 1.84 1.84 4.312-4.323 4.323 4.323 1.84-1.84-4.323-4.323 4.323-4.312z"></path>
      <path d="M15.994 0c-8.816 0-15.994 7.179-15.994 15.994s7.179 15.994 15.994 15.994 15.994-7.179 15.994-15.994-7.168-15.994-15.994-15.994zM15.994 29.393c-7.382 0-13.398-6.005-13.398-13.398s6.016-13.398 13.398-13.398 13.398 6.005 13.398 13.398-6.005 13.398-13.398 13.398z"></path>
    </SVG>
  );
};
